// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/Homepage/tech-blockchain.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-2-container {
    width: 100%;
    position: relative;
    margin-bottom: 15rem
}

.blockchain-bg {
    width: 100%;
    height: 80dvh;
}

.section-2 {
    position: absolute;
    top: 30%;
    left: 10%;
    background-color: #0B63E5;
    color: white;
    width: 700px;
    padding: 3% 1% 1% 2%;
    border-top-right-radius: 50px;
}

.section-2-line1 {
    font-size: 22px;
    font-weight: bold;
}

.section-2-line2 {
    font-size: 3rem;
    width: 80%;
    font-weight: lighter;
    margin: 0;
}

.section-2-line3 {
    font-size: 3rem;
    font-weight: bolder;
    margin: 0;
    padding: 0;
}

.section-2-line4 {
    font-size: 1.125rem;
    width: 80%;
    margin-bottom: 2rem;
}

.section-2-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media screen and (min-width:300px) and (max-width:490px) {
    .section-2-container {
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        padding: 5% 0;
        margin-bottom: var(--margin-bottom-mobile);
    }

    .section-2-container>img {
        display: none;
    }

    .section-2 {
        position: relative;
        width: 90%;
        top: 0;
        left: 0;
        margin: auto;

        & img:nth-child(1) {
            width: 30%;
        }
    }

    .section-2-line1 {
        font-size: 0.75rem;
    }

    .section-2-line2,
    .section-2-line3 {
        width: 80%;
        font-size: 1.75rem;
    }

    .section-2-line4 {
        font-size: 0.625rem;
    }
}


@media screen and (min-width:601px) and (max-width:840px) {
    .section-2 {
        width: 50%;
        top: 20%;
    }

    .section-2-line1 {
        font-size: 1rem;
    }

    .section-2-line2,
    .section-2-line3 {
        width: 90%;
        font-size: 2rem;
    }

    .section-2-line4 {
        font-size: 0.8rem;
    }

    .itlogo {
        width: 10%;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Homepage/Section2.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,kBAAkB;IAClB;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,oBAAoB;IACpB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI;QACI,yDAAkE;QAClE,aAAa;QACb,0CAA0C;IAC9C;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,MAAM;QACN,OAAO;QACP,YAAY;;QAEZ;YACI,UAAU;QACd;IACJ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,UAAU;QACV,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;AACJ;;;AAGA;IACI;QACI,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,UAAU;IACd;AACJ","sourcesContent":[".section-2-container {\r\n    width: 100%;\r\n    position: relative;\r\n    margin-bottom: 15rem\r\n}\r\n\r\n.blockchain-bg {\r\n    width: 100%;\r\n    height: 80dvh;\r\n}\r\n\r\n.section-2 {\r\n    position: absolute;\r\n    top: 30%;\r\n    left: 10%;\r\n    background-color: #0B63E5;\r\n    color: white;\r\n    width: 700px;\r\n    padding: 3% 1% 1% 2%;\r\n    border-top-right-radius: 50px;\r\n}\r\n\r\n.section-2-line1 {\r\n    font-size: 22px;\r\n    font-weight: bold;\r\n}\r\n\r\n.section-2-line2 {\r\n    font-size: 3rem;\r\n    width: 80%;\r\n    font-weight: lighter;\r\n    margin: 0;\r\n}\r\n\r\n.section-2-line3 {\r\n    font-size: 3rem;\r\n    font-weight: bolder;\r\n    margin: 0;\r\n    padding: 0;\r\n}\r\n\r\n.section-2-line4 {\r\n    font-size: 1.125rem;\r\n    width: 80%;\r\n    margin-bottom: 2rem;\r\n}\r\n\r\n.section-2-bottom {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n@media screen and (min-width:300px) and (max-width:490px) {\r\n    .section-2-container {\r\n        background-image: url('../../assets/Homepage/tech-blockchain.png');\r\n        padding: 5% 0;\r\n        margin-bottom: var(--margin-bottom-mobile);\r\n    }\r\n\r\n    .section-2-container>img {\r\n        display: none;\r\n    }\r\n\r\n    .section-2 {\r\n        position: relative;\r\n        width: 90%;\r\n        top: 0;\r\n        left: 0;\r\n        margin: auto;\r\n\r\n        & img:nth-child(1) {\r\n            width: 30%;\r\n        }\r\n    }\r\n\r\n    .section-2-line1 {\r\n        font-size: 0.75rem;\r\n    }\r\n\r\n    .section-2-line2,\r\n    .section-2-line3 {\r\n        width: 80%;\r\n        font-size: 1.75rem;\r\n    }\r\n\r\n    .section-2-line4 {\r\n        font-size: 0.625rem;\r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width:601px) and (max-width:840px) {\r\n    .section-2 {\r\n        width: 50%;\r\n        top: 20%;\r\n    }\r\n\r\n    .section-2-line1 {\r\n        font-size: 1rem;\r\n    }\r\n\r\n    .section-2-line2,\r\n    .section-2-line3 {\r\n        width: 90%;\r\n        font-size: 2rem;\r\n    }\r\n\r\n    .section-2-line4 {\r\n        font-size: 0.8rem;\r\n    }\r\n\r\n    .itlogo {\r\n        width: 10%;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
